export default "__VITE_ASSET__aZnm6LzR__"